import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { rem } from '@/shared/ui/core';

const modifiers = {
  large: () => ({
    styles: `
      width: ${rem(80)};
      height: ${rem(80)};
    `,
  }),
  xLarge: () => ({
    styles: `
      width: ${rem(120)};
      height: ${rem(120)};
    `,
  }),
  wBorder: ({ theme }) => ({
    styles: `
      border: solid ${rem(5)} ${theme.primary.main};
      `,
  }),
};

export const ImageRoundedStyled = styled.div.attrs({
  className: 'component__imageRounded',
})`
  width: ${rem(50)};
  height: ${rem(50)};
  line-height: 1;
  background-color: #EEE;
  border-radius: 100%;
  display: block;
  overflow: hidden;
  position: relative;
  ${applyStyleModifiers(modifiers)}

  img {
    width: 105%;
    height: 105%;
    object-fit: cover;
  }

`;
